module.exports = __webpack_public_path__ + "media/images/icons/outlined/sketch-9ad16f09dbb5374d80f187524c882463.svg";